import React, { useState, useEffect, useRef } from "react";
import Image from "../../../../assets/img/ShiproneLogo.png";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { FieldArray, FormikProvider, Form, Formik } from "formik";
import { sanitizeInput } from "../../../../utils";
import CustomeModal from "../../../../component/modal-popup/customeModal";
import swal from "@sweetalert/with-react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import DragAndDropComponent from "./DragAndDropComponent";
import { useNavigate, useLocation } from "react-router-dom";
import SimpleBarReact from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

// Redux
import { getConfigurationData } from "../../../../redux/actions/configurationAction";
import { getDepartment } from "../../../../redux/actions/department";
import {
  getCollaboratorByCompany,
  getUserListDepartmentWise,
} from "../../../../redux/actions/user";
import {
  Customer,
  Collaborator,
} from "../../../../constant/AuthenticationConstant";
import {
  getAssignmentDataByConfigurationId,
  getAssignmentActivityList,
} from "../../../../redux/actions/assignmentAction";
import {
  RESET_TODO_PERFORMANCE,
  SET_PREVIOUS_PATH,
} from "../../../../redux/constants";
import Loader from "react-spinner-loader";
import { deleteBookingById } from "../../../../redux/actions/booking";
import { getWorkingHours } from "../../../../redux/actions/company";

function PurchaseOrderAssignment({ assignmentFormik, workflowLoader }) {
  const navigate = useNavigate();
  const location = useLocation();

  // State
  const [showWaterMark, setShowWaterMark] = useState(true);
  const [workflowOptions, setWorkflowOptions] = useState([]);
  const [teamsOptions, setTeamsOptions] = useState([]);
  const [usersOptions, setUsersOptions] = useState([]);
  const [customerAndCollaboratorOptions, setCustomerAndCollaboratorOptions] =
    useState([]);
  const [todoOptions, setTodoOptions] = useState([]);
  const [selectedWorkflow, setSelectedWorkflow] = useState();
  const [apiLoader, setApiLoader] = useState(false);
  const [workingHours, setWorkingHours] = useState({});

  // Redux
  const dispatch = useDispatch();
  const { company } = useSelector((state) => state.auth);
  const { configurationData } = useSelector(
    (state) => state.configurationReducer
  );

  // Function to GET Workflow List
  const getWorkflowList = () => {
    const request = {
      company_id: company.id,
      onError: () => {},
    };
    dispatch(getConfigurationData(request));
  };

  // Function to GET Team list
  const getTeamsList = () => {
    dispatch(
      getDepartment((res) => {
        if (res.status === 0) {
          swal({
            content: (
              <CustomeModal type="error" title="Error!" content={res.message} />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        } else {
          setTeamsOptions(
            res.data.data.map((teamItem) => {
              const obj = {
                label: teamItem.name,
                value: teamItem.id,
              };
              return obj;
            })
          );
        }
      }, company.id)
    );
  };

  // Function to GET User List
  const getUserList = () => {
    const request = {
      company_id: company.id,
      onSuccess: (result) => {
        setUsersOptions(
          result.map((userItem) => {
            const obj = {
              label: userItem.name,
              value: userItem.id,
            };
            return obj;
          })
        );
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getUserListDepartmentWise(request));
  };

  // Function to GET Customer and Collaborator List
  const getCustomerAndCollaboratorList = () => {
    const request = {
      company_id: company.id,
      onSuccess: (result) => {
        setCustomerAndCollaboratorOptions(
          result.map((collaboratorItem) => {
            const obj = {
              label: collaboratorItem.name,
              value: collaboratorItem.collaborator_id,
              type: collaboratorItem.type,
            };
            return obj;
          })
        );
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getCollaboratorByCompany(request));
  };

  // Function to GET To Do List
  const getToDoList = () => {
    const request = {
      company_id: company.id,
      onSuccess: (result) => {
        setTodoOptions(
          result.map((todoItem) => {
            const obj = {
              label: todoItem.name,
              value: todoItem.id,
            };
            return obj;
          })
        );
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getAssignmentActivityList(request));
  };

  // Function to GET Assignment data by workflow_id
  const getToDoAssignmentByWorkflowId = () => {
    setApiLoader(true);
    const request = {
      configurationId: selectedWorkflow.workflow_id,
      onSuccess: (data) => {
        assignmentFormik.setFieldValue(
          `workflows[${selectedWorkflow.index}].assignments`,
          data.map((assignmentItem, index) => {
            const obj = {
              activity_id: assignmentItem.activity_id,
              department_id: assignmentItem.activity.department,
              user_id: assignmentItem.activity.user,
              sequence: assignmentItem.sequence,
              is_mandatory: assignmentItem.is_mandatory,
              link_activity: assignmentItem.link_activity,
              loop_activity: assignmentItem.loop_activity,
              duration: assignmentItem.duration,
              collaborator_id: assignmentItem.activity.collaborator_id,
              dept_timzone: assignmentItem.activity.dept_timzone,
              user_timzone: assignmentItem.activity.user_timzone,
              estimated_time: "",
              reminder_time: "",
              departmentSelect: "",
              userSelect: "",
              reminderTimeDropdownVal: "",
              status: "pending",
            };

            if (assignmentItem.activity.department) {
              obj.departmentSelect = {
                label: assignmentItem.activity.assign_department.name,
                value: assignmentItem.activity.assign_department.id,
              };
            } else if (
              obj.collaborator_id &&
              !assignmentItem.activity.is_assign_to_customer
            ) {
              obj.departmentSelect = {
                label: "Collaborator",
                value: Collaborator,
              };
            } else if (
              !obj.collaborator_id &&
              assignmentItem.activity.is_assign_to_customer
            ) {
              obj.departmentSelect = {
                label: "Customer",
                value: Customer,
              };
            }

            if (obj.collaborator_id) {
              obj.userSelect = customerAndCollaboratorOptions.find(
                (item) => item.value === obj.collaborator_id
              );
            } else if (obj.user_id) {
              obj.userSelect = usersOptions.find(
                (item) => item.value === obj.user_id
              );
            }

            return obj;
          })
        );
        setApiLoader(false);
      },
      onError: () => {
        setApiLoader(false);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getAssignmentDataByConfigurationId(request));
  };

  useEffect(() => {
    getWorkflowList();
    getTeamsList();
    getUserList();
    getCustomerAndCollaboratorList();
    getToDoList();
  }, []);

  useEffect(() => {
    if (selectedWorkflow) {
      getToDoAssignmentByWorkflowId();
    }
  }, [selectedWorkflow]);

  // Setting Workflow Options
  useEffect(() => {
    if (configurationData?.data?.length > 0) {
      setWorkflowOptions(
        configurationData.data.map((workflowItem) => {
          const obj = {
            label: workflowItem.configuration_name,
            value: workflowItem.configuration_id,
          };
          return obj;
        })
      );
    }
  }, [configurationData]);

  useEffect(() => {
    const request = {
      onSuccess: (result) => {

        if(result.status){
          setWorkingHours(result.data);
        }

      },
      onError: (error) => {
        console.log("error", error);
      },
    };
    dispatch(getWorkingHours(request));
  }, []);

  const handleDeleteWorkflow = (data) => {
    if(data?.activity_assignment_id){
      dispatch(deleteBookingById(data?.activity_assignment_id, (res) => {}))
    }
  }

  return (
    <div
      className="h-screen max-w-full overflow-y-hidden"
      style={{ height: "calc(100vh - 148px)" }}
    >
      {workflowLoader ? (
        <div className="flex justify-center p-2 my-2 whitespace-nowrap w-full">
          <Loader show={workflowLoader} />
        </div>
      ) : (
        <>
          {/* Watermark */}
          {showWaterMark &&
            !assignmentFormik.values.workflows.some(
              (item) => item?.activity_assignment_id
            ) && (
              <div className="w-full h-full flex justify-center items-center">
                <div
                  className="w-[80%] h-[80%] bg-center bg-opacity-25 flex justify-center items-center"
                  style={{
                    backgroundImage:
                      "linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url(" +
                      Image +
                      ")",
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  <div className="text-center space-y-3">
                    <h4 className="text-[15px]  tracking-tight font-bold text-[#1E293B] ">
                      Add A Workflow
                    </h4>
                    <p className="text-[15px]  tracking-tight text-[#1E293B]">
                      to start assigning to dos and end dates
                    </p>
                    <button
                      className="btn bg-[--bg-color-500] text-white mt-1"
                      onClick={() => setShowWaterMark(false)}
                    >
                      Add Workflow
                    </button>
                  </div>
                </div>
              </div>
            )}

          <div className="py-6 max-w-full h-full overflow-x-auto overflow-y-hidden scrollbar scrollbar-w-2 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-100">
            <FormikProvider value={assignmentFormik}>
              <Form autoComplete="off" noValidate>
                <FieldArray
                  name="workflows"
                  render={(arrayHelpers) => (
                    <div className="flex space-x-4 items-start">
                      {assignmentFormik.values.workflows.map((item, index) => {
                        return (
                          <div className="space-y-6">
                            {/* Workflow Form */}
                            <div className="rounded-md w-[440px] py-6 px-4 bg-[--bg-color-50] space-y-4">
                              <div className="flex items-center space-x-4">
                                <input
                                  type="text"
                                  className="form-input !border-t-0 !border-r-0 !border-l-0 !border-b-2 !border-[#D9D9D9] !bg-[--bg-color-50] w-full !rounded-none !shadow-none !pt-0 !text-base font-semibold text-[#1E293B] !pl-0"
                                  placeholder="Workflow Name"
                                  onChange={(e) => {
                                    const value = sanitizeInput(e.target.value);
                                    assignmentFormik.setFieldValue(
                                      `workflows[${index}].alias`,
                                      value
                                    );
                                  }}
                                  value={
                                    assignmentFormik.values.workflows[index]
                                      .alias
                                  }
                                />
                                <button
                                  disabled={!item?.activity_assignment_id}
                                  className={`btn ${
                                    item?.activity_assignment_id
                                      ? "bg-[--bg-color-500] hover:bg-[--bg-color-600]"
                                      : "bg-[--bg-color-300]"
                                  } text-white !py-[5px] !px-5 !rounded-md`}
                                  onClick={() => {
                                    dispatch({ type: RESET_TODO_PERFORMANCE });

                                    navigate(
                                      `/todo/performance/${item?.activity_assignment_id}`
                                    );
                                  }}
                                >
                                  View
                                </button>
                              </div>
                              <div>
                                <label
                                  className={`block text-sm font-medium mb-1 leading-3 tracking-tight`}
                                >
                                  Workflow
                                </label>
                                <Select
                                  className="basic-single text-sm unresetText"
                                  styles={{
                                    control: (provided) => ({
                                      ...provided,
                                      backgroundColor: "white",
                                      borderColor: "lightgray",
                                    }),
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                    placeholder: (provided, state) => ({
                                      ...provided,
                                      color: "#9297A2",
                                      fontSize: "14px",
                                    }),
                                  }}
                                  classNames={{
                                    control: (style) => {
                                      return `!border !shadow-sm ${
                                        style.isFocused
                                          ? "!border-[--bg-color-300]/50"
                                          : "!border-slate-200 hover:!border-gray-300"
                                      }`;
                                    },
                                    container: (style) => {
                                      return "!h-[37.5px] !font-inter !text-sm";
                                    },
                                    menuList: (style) => {
                                      return `!max-h-[200px]`;
                                    },
                                  }}
                                  onChange={(workflowData) => {
                                    assignmentFormik.setFieldValue(
                                      `workflows[${index}].workflow_id`,
                                      workflowData.value
                                    );
                                    setSelectedWorkflow({
                                      workflow_id: workflowData.value,
                                      index,
                                    });
                                  }}
                                  value={
                                    assignmentFormik.values.workflows[index]
                                      .workflow_id
                                      ? workflowOptions.find(
                                          (workflowEle) =>
                                            workflowEle.value ===
                                            assignmentFormik.values.workflows[
                                              index
                                            ].workflow_id
                                        )
                                      : ""
                                  }
                                  options={workflowOptions}
                                  placeholder="Select Workflow"
                                />
                              </div>
                            </div>
                            {/* To Dos related to Workflow */}
                            {apiLoader ? (
                              <div className="w-full h-full flex items-center justify-center">
                                <Loader />
                              </div>
                            ) : (
                              <DndProvider backend={HTML5Backend}>
                                <div className="h-screen">
                                  <SimpleBarReact
                                    style={{ maxHeight: "calc(100vh - 385px)" }}
                                  >
                                    <div
                                      className="w-[440px] space-y-4"
                                    >
                                      <FieldArray
                                        name={`workflows[${index}].assignments`}
                                        render={(arrayHelpersToDo) => {
                                          return (
                                            <>
                                              {/* {console.log('data ==>', item.assignments)} */}
                                              {item.assignments.map(
                                                (element, i) => {
                                                  return (
                                                    <DragAndDropComponent
                                                      assignmentFormik={
                                                        assignmentFormik
                                                      }
                                                      arrayHelpersToDo={
                                                        arrayHelpersToDo
                                                      }
                                                      index={index}
                                                      i={i}
                                                      element={element}
                                                      todoOptions={todoOptions}
                                                      customerAndCollaboratorOptions={
                                                        customerAndCollaboratorOptions
                                                      }
                                                      usersOptions={
                                                        usersOptions
                                                      }
                                                      teamsOptions={
                                                        teamsOptions
                                                      }
                                                      workingHours={workingHours}
                                                    />
                                                  );
                                                }
                                              )}
                                              {/* Add To Do Button */}
                                              {item?.assignments?.length ===
                                                0 && (
                                                <div className="w-full">
                                                  <button
                                                    className="w-full btn bg-white border-slate-200 hover:border-slate-300 text-[--bg-color-500] cursor-pointer font-semibold"
                                                    onClick={() => {
                                                      arrayHelpersToDo.push({
                                                        // activity_assignment_mapping_id:
                                                        //   "", // used while updating
                                                        activity_id: null,
                                                        department_id: null,
                                                        user_id: null,
                                                        sequence: 1,
                                                        is_mandatory: false,
                                                        link_activity: null,
                                                        loop_activity: null,
                                                        duration: 0,
                                                        collaborator_id: null,
                                                        estimated_time: null,
                                                        reminder_time: null,
                                                        departmentSelect: "",
                                                        userSelect: "",
                                                        reminderTimeDropdownVal:
                                                          "",
                                                        status: "pending",
                                                      });
                                                    }}
                                                  >
                                                    + Add To Do
                                                  </button>
                                                </div>
                                              )}

                                              <div className="w-full">
                                                <button
                                                  type="button"
                                                  onClick={(e) =>{
                                                    e.stopPropagation();
                                                    if(item?.activity_assignment_id){
                                                      swal({
                                                        content: (
                                                          <CustomeModal
                                                            type="delete"
                                                            title="Are you sure?"
                                                            content="All of your data will be permanently removed from our servers forever. This action cannot be undone."
                                                            onDelete={() =>{
                                                              handleDeleteWorkflow(item);
                                                              arrayHelpers.remove(index);
                                                            }}
                                                          />
                                                        ),
                                                        buttons: false,
                                                        closeOnClickOutside: false,
                                                        closeOnEsc: false,
                                                      });
                                                    }else{
                                                      arrayHelpers.remove(index);
                                                    }
                                                  }}
                                                  className="w-full btn !bg-[#EB5757] text-[13px] font-semibold text-white"
                                                >
                                                  Delete Workflow
                                                </button>
                                              </div>
                                            </>
                                          );
                                        }}
                                      />
                                    </div>
                                  </SimpleBarReact>
                                </div>
                              </DndProvider>
                            )}
                          </div>
                        );
                      })}

                      <h4
                        className="text-sm font-semibold text-[--bg-color-500] tracking-tight leading-5 cursor-pointer min-w-[108px]"
                        onClick={() =>
                          arrayHelpers.push({
                            alias: "",
                            workflow_id: "",
                            assignments: [],
                          })
                        }
                      >
                        + Add Workflow
                      </h4>
                    </div>
                  )}
                />
              </Form>
            </FormikProvider>
          </div>
        </>
      )}
    </div>
  );
}

export default PurchaseOrderAssignment;
